import { QuesItem } from './ques.type';
import { QuesChoiceResponseComponent } from './ques-choice-response/ques-choice-response.component';
import { ComponentRef } from '@angular/core';

//Add new components in this map to be used for rendering in the sections
export const QuesComponentMap: QuesItem[] = [
    new QuesItem("QuesChoiceResponse",QuesChoiceResponseComponent,[])
];

export class QuestionMap {
    Id: any;
    ComponentRef: ComponentRef<any>;
}
